import { TaskAPI } from 'api/tasks';
import { DuplicateTasksInStoreProps } from 'components/organisms/tasks/duplicate-task';
import { FetchStatus } from 'data/core';
import { taskNormalizer } from 'data/tasks/schema';
import { saveTasks } from 'data/tasks/slice';
import { created } from 'stores/tasks';
import { withValidCustomFieldsForData } from 'utils/duplicate-fields-transformer';
import { TaskLookupItem } from 'utils/to-store-task';

const createSubTasks = (
  projectId,
  task,
  requestId,
  taskTree: TaskLookupItem[],
  dispatch,
  to_row,
) => {
  task.subTaskOrder?.forEach(async (subTaskId) => {
    const subTask = await TaskAPI.getTask(projectId, subTaskId);
    const {
      entities: {
        tasks: { [subTaskId]: normalized },
      },
    } = taskNormalizer(subTask);

    dispatch(
      created([
        {
          ...to_row(normalized),
          taskTree: [
            ...taskTree,
            {
              taskName: normalized.taskName,
              taskId: normalized.taskId,
              parentTask: normalized.parentTask,
            },
          ],
        },
        requestId,
      ]),
    );
    createSubTasks(
      projectId,
      subTask,
      requestId,
      [
        ...taskTree,
        {
          taskName: normalized.taskName,
          taskId: normalized.taskId,
          parentTask: normalized.parentTask,
        },
      ] as TaskLookupItem[],
      dispatch,
      to_row,
    );
  });
};

export const duplicateTasksToStore = async ({
  projectId,
  data,
  requestId,
  dispatch,
  to_row,
  shouldUpdateTasksInV1Store,
}: DuplicateTasksInStoreProps) => {
  /* eslint-disable-next-line no-restricted-syntax */
  for (const taskId of data) {
    /* eslint-disable-next-line no-await-in-loop */
    const task = await TaskAPI.getTask(projectId, taskId);
    const updatedTask = {
      ...task,
      fields: task.fields.map(withValidCustomFieldsForData),
    };

    const {
      entities: {
        tasks: { [taskId]: normalized },
      },
    } = taskNormalizer(updatedTask);

    dispatch(created([to_row(normalized), requestId]));
    if (shouldUpdateTasksInV1Store) {
      dispatch(saveTasks({ data: [task], fetchStatus: FetchStatus.Loaded }));
    }
    createSubTasks(
      projectId,
      task,
      requestId,
      to_row(normalized).taskTree,
      dispatch,
      to_row,
    );
  }
};
